<template>
    <div class="cardbalanceDetail">
        <nav-bar :titleText="title" fontColor="#333333" @goBack="goBack"></nav-bar>
        <div class="cardbalanceDetail_content" v-if="data.type==1&&data.is_admin==0">
            <div class="title_money">+{{data.order_amount}}</div>
            <div class="content_item">
                <span class="content_itemleft">店铺名称</span>
                <span class="content_itemright">{{data.shop_name}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">手机号码</span>
                <span class="content_itemright">{{data.member_mobile}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">共享金额</span>
                <span class="content_itemright">{{data.actual_amount}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">赠送金额</span>
                <span class="content_itemright">{{data.present_amount}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">红包抵扣</span>
                <span class="content_itemright">{{data.deduct_credit_amount?data.deduct_credit_amount:'0.00'}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">充值时间</span>
                <span class="content_itemright">{{data.created_at}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">订单编号</span>
                <span class="content_itemright" ref="copytxt">{{data.order_sn}}</span>
                <span class="copybtn" @click="copyorder()">复制</span>
            </div>
        </div>
        <div class="cardbalanceDetail_content" v-if="data.type==2&&data.is_admin==0">
            <div class="title_money">-{{data.order_amount}}</div>
            <div class="content_item">
                <span class="content_itemleft">店铺名称</span>
                <span class="content_itemright">{{data.shop_name}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">手机号码</span>
                <span class="content_itemright">{{data.member_mobile}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">共享金额</span>
                <span class="content_itemright">{{data.actual_amount}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">赠送金额</span>
                <span class="content_itemright">{{data.present_amount}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">核销时间</span>
                <span class="content_itemright">{{data.created_at}}</span>
            </div>
            <div class="content_item">
                <span class="content_itemleft">订单编号</span>
                <span class="content_itemright" ref="copytxt">{{data.order_sn}}</span>
                <span class="copybtn" @click="copyorder()">复制</span>
            </div>
        </div>
        <div class="cardbalanceDetail_content" v-if="data.type==1&&data.is_admin!=0">
            <div class="title_money">+{{data.order_amount}}</div>
            <div class="content_item">
                <span class="content_itemleft">操作时间</span>
                <span class="content_itemright">{{data.created_at}}</span>
            </div>
            <div class="content_items">
                <span class="content_itemleft">备注内容</span>
                <span class="content_itemrights">{{data.comment}}</span>
            </div>
        </div>
        <div class="cardbalanceDetail_content" v-if="data.type==2&&data.is_admin!=0">
            <div class="title_money">-{{data.order_amount}}</div>
            <div class="content_item">
                <span class="content_itemleft">操作时间</span>
                <span class="content_itemright">{{data.created_at}}</span>
            </div>
            <div class="content_items">
                <span class="content_itemleft">备注内容</span>
                <span class="content_itemrights">{{data.comment}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from './components/navBar'
export default {
    name:'cardbalanceDetail',
    data(){
        return{
            title:'卡包充值详情',
            data:{}
        }
    },
    components:{
        navBar,
    },
    mounted(){
        this.data=JSON.parse(this.$route.query.item)
        if(this.data.type==1&&this.data.is_admin==0){
            this.title='卡包充值详情'
        }else if(this.data.type==2&&this.data.is_admin==0){
            this.title='卡包核销详情'
        }else if(this.data.type==1&&this.data.is_admin!=0){
            this.title='平台操作增加详情'
        }else if(this.data.type==2&&this.data.is_admin!=0){
            this.title='平台操作扣减详情'
        }
    },
    methods:{
         goBack() {
            this.$router.go(-1)
        }, 
        copyorder(){
            const agent_range = document.createRange();
            agent_range.selectNode(this.$refs.copytxt);
            const agent_selection = window.getSelection();
            if(agent_selection.rangeCount > 0) agent_selection.removeAllRanges();
            agent_selection.addRange(agent_range);
            document.execCommand('Copy');
            this.$toast('复制成功')
            agent_selection.removeAllRanges()
        }
    }
}
</script>

<style lang="less" scoped>
.cardbalanceDetail{
    background: #F5F6F7;
    height: 100%;
    overflow: auto;
    padding-top: 88px;
    box-sizing: border-box;
    .cardbalanceDetail_content{
        padding: 30px 12px;
        box-sizing: border-box;
        background: #fff;
        margin-top: 10px;
        .title_money{
            text-align: center;
            font-size: 28px;
            font-weight: 600;
            color: #333333;
            margin-bottom: 10px;
        }
        .content_item{
            margin-top: 20px;
            font-size: 16px;
            font-weight: 400;
            display: flex;
            .content_itemleft{
                flex: 1;
                padding: 0 12px;
                box-sizing: border-box;
                color: #666666;
                line-height: 24px;
            }
            .content_itemright{
                flex: 3;
                // padding: 0 12px;
                // box-sizing: border-box;
                color: #333333;
                line-height: 24px;
            }
            .copybtn{
                font-size: 13px;
                font-weight: 500;
                color: #F9591B;
                line-height: 24px;
            }
        }
        .content_items{
            margin-top: 20px;
            font-size: 16px;
            font-weight: 400;
            .content_itemleft{
                display: inline-block;
                padding: 0 12px;
                box-sizing: border-box;
                color: #666666;
                margin-bottom: 10px;
                line-height: 24px;
            }
            .content_itemrights{
                display: block;
                background: #F5F6F7;
                border-radius: 2px;
                font-size: 16px;
                font-weight: 400;
                color: #666666;
                padding: 10px;
                box-sizing: border-box;
                margin: 0 12px;
                line-height: 24px;
            }
        }
    }
}
</style>